import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { SvgIcon } from ':shared/enums/svg-icon.enum';

@Component({
    selector: 'app-diagnostic-header',
    templateUrl: './diagnostic-header.component.html',
    styleUrls: ['./diagnostic-header.component.scss'],
    imports: [MatIcon, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticHeaderComponent {
    readonly subtitle = input.required<string>();

    readonly SvgIcon = SvgIcon;
}
